import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenExpirationService {

  private checkInterval = 10000; // Check every 10 seconds
  private subscription: Subscription | null = null;

  constructor(private authService: AuthService, private router: Router) {}

  startTokenCheck(): void {
    this.subscription = interval(this.checkInterval).subscribe(() => {
      if (!this.authService.isAuthenticated()) {
        this.authService.logout();
        this.router.navigate(['/login']);
      }
    });
  }

  stopTokenCheck(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
